<ng-template #parameterTrailingMenuBar>
  <soft-menu-bar-button
    [tooltip]="('#PMS_ROSTER.REFRESH' | translate) ?? ''"
    variant="outline"
    [iconOnly]="true"
    icon="fa-regular fa-arrows-rotate"
    (execute)="this.service.refreshEvents()"
  />
  <!--spacer-->
  <div class="h-full min-h-8 w-px select-none mx-1">&nbsp;</div>
  <soft-menu-bar-split-button
    [label]="('#PMS_ROSTER.NEW_ENTRY' | translate) ?? ''"
    [tooltip]="('#PMS_ROSTER.NEW_ENTRY' | translate) ?? ''"
    variant="primary"
    icon="fa-regular fa-plus"
    [responsive]="true"
    (execute)="this.service.handleContextMenuAction('createEmpty')"
  >
    <soft-menu
      *softMenuBarDropdownContent
      class="min-w-38"
      style="
        border-radius: 8px;
        background: var(--elevation-surface-overlay, #fff);
        box-shadow:
          0 0 0 1px var(--elevation-shadow-raised-strong-perimeter, rgba(0, 0, 0, 0.12)),
          0 8px 24px -4px
            var(--elevation-shadow-raised-strong-spread, rgba(0, 0, 0, 0.08)),
          0 4px 6px -1px
            var(--elevation-shadow-raised-strong-default, rgba(0, 0, 0, 0.15));
        overflow: hidden;
      "
    >
      <soft-menu-item
        value="plan"
        [label]="('#PMS_ROSTER.PLAN_ENTRY' | translate) ?? ''"
        icon="fa-regular fa-database"
        (click)="this.service.handleContextMenuAction('createPlanEntry')"
      />
      <soft-menu-item
        value="appointment"
        [label]="('#PMS_ROSTER.APPOINTMENT' | translate) ?? ''"
        icon="fa-regular fa-calendar"
        (click)="this.service.handleContextMenuAction('createAppointment')"
      />
    </soft-menu>
  </soft-menu-bar-split-button>
</ng-template>

<ng-template #viewLeadingMenuBar>
  <button
    type="button"
    (click)="hostComponent.minimize.set(!hostComponent.minimize())"
    class="hover:bg-hover p-2 cursor-pointer rounded-sm"
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66501 0.665001V12.665M9.33168 8.665L7.33168 6.665L9.33168 4.665M1.99834 0.665001H11.3317C12.0681 0.665001 12.665 1.26195 12.665 1.99833V11.3317C12.665 12.068 12.0681 12.665 11.3317 12.665H1.99834C1.26196 12.665 0.665009 12.068 0.665009 11.3317V1.99833C0.665009 1.26195 1.26196 0.665001 1.99834 0.665001Z"
        stroke="currentColor"
        stroke-width="1.33"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
  <div class="self-stretch w-px bg-border select-none mx-1"></div>
  <soft-menu-bar-dropdown
    icon="fa-regular fa-calendar-range"
    [label]="viewTypeLabel()"
    [tooltip]="('#PMS_ROSTER.VIEW_TYPE' | translate) + ':\n' + viewTypeLabel()"
    [responsive]="true"
    [hideChevron]="true"
  >
    <soft-menu *softMenuBarDropdownContent class="min-w-52">
      <div class="px-3 py-2 border-b text-sm font-semibold">
        {{ '#PMS_ROSTER.VIEW_TYPE' | translate }}
      </div>
      @for (opt of viewTypeOptions(); track opt.v) {
        <soft-menu-item
          [value]="opt.v"
          [label]="opt.l"
          [selected]="hostComponent.calendarViewType() === opt.v"
          (click)="hostComponent.calendarViewType.set(opt.v)"
        />
      }
    </soft-menu>
  </soft-menu-bar-dropdown>
  <div class="self-stretch w-px bg-border select-none mx-1"></div>
  <soft-menu-bar-dropdown
    icon="fa-regular fa-arrows-left-right"
    [label]="columnWidthLabel()"
    [tooltip]="('#PMS_ROSTER.COLUMN_WIDTH' | translate) + ':\n' + columnWidthLabel()"
    [responsive]="true"
    [hideChevron]="true"
  >
    <soft-menu *softMenuBarDropdownContent class="min-w-52">
      <div class="px-3 py-2 border-b text-sm font-semibold">
        {{ '#PMS_ROSTER.COLUMN_WIDTH' | translate }}
      </div>
      @for (opt of columnWidthOptions(); track opt.v) {
        <soft-menu-item
          [value]="opt.v"
          [label]="opt.l"
          [selected]="hostComponent.calendarColumnWidth() === opt.v"
          (click)="hostComponent.calendarColumnWidth.set(opt.v)"
        />
      }
    </soft-menu>
  </soft-menu-bar-dropdown>
  <div class="self-stretch w-px bg-border select-none mx-1"></div>
  <soft-menu-bar-dropdown
    icon="fa-regular fa-filter"
    [tooltip]="('#PMS_ROSTER.EVENT_TYPES' | translate) ?? ''"
    [responsive]="true"
    [hideChevron]="true"
  >
    <span class="text-sm whitespace-nowrap">
      {{ '#PMS_ROSTER.EVENT_TYPES' | translate }}
    </span>
    <span
      class="inline-flex items-center justify-center rounded-md border text-[12px] font-semibold leading-none min-w-4 h-4 px-1.5 py-2"
    >
      {{ selectedEventTypeFilter().length }}
    </span>

    <soft-menu *softMenuBarDropdownContent class="min-w-52">
      <div class="px-3 py-2 border-b text-sm font-semibold">
        {{ '#PMS_ROSTER.EVENT_TYPES' | translate }}
      </div>
      <div
        class="py-2 px-3 flex items-center gap-2 hover:bg-hover cursor-pointer text-sm"
        (click)="$event.stopPropagation(); toggleSelectedEventType('tickets')"
      >
        <span
          class="shrink-0 pointer-events-none inline-flex items-center justify-center"
          style="
            width: 15px;
            height: 15px;
            border-radius: 4px;
            border: 1px solid var(--action-surface-primary, #1f74b2);
          "
          [style.background]="
            ('tickets' | in: selectedEventTypeFilter())
              ? 'var(--action-surface-primary, #1F74B2)'
              : 'transparent'
          "
        >
          @if ('tickets' | in: selectedEventTypeFilter()) {
            <i class="fa-solid fa-check text-white" style="font-size: 9px"></i>
          }
        </span>
        <span>{{ '#PMS_ROSTER.FILTER_TICKETS_OBJECTS_TASKS' | translate }}</span>
      </div>

      <div
        class="py-2 px-3 flex items-center gap-2 hover:bg-hover cursor-pointer text-sm"
        (click)="$event.stopPropagation(); toggleSelectedEventType('appointments')"
      >
        <span
          class="shrink-0 pointer-events-none inline-flex items-center justify-center"
          style="
            width: 15px;
            height: 15px;
            border-radius: 4px;
            border: 1px solid var(--action-surface-primary, #1f74b2);
          "
          [style.background]="
            ('appointments' | in: selectedEventTypeFilter())
              ? 'var(--action-surface-primary, #1F74B2)'
              : 'transparent'
          "
        >
          @if ('appointments' | in: selectedEventTypeFilter()) {
            <i class="fa-solid fa-check text-white" style="font-size: 9px"></i>
          }
        </span>
        <span>{{ '#PMS_ROSTER.FILTER_APPOINTMENTS' | translate }}</span>
      </div>

      <div
        class="py-2 px-3 flex items-center gap-2 hover:bg-hover cursor-pointer text-sm"
        (click)="$event.stopPropagation(); toggleSelectedEventType('holidays')"
      >
        <span
          class="shrink-0 pointer-events-none inline-flex items-center justify-center"
          style="
            width: 15px;
            height: 15px;
            border-radius: 4px;
            border: 1px solid var(--action-surface-primary, #1f74b2);
          "
          [style.background]="
            ('holidays' | in: selectedEventTypeFilter())
              ? 'var(--action-surface-primary, #1F74B2)'
              : 'transparent'
          "
        >
          @if ('holidays' | in: selectedEventTypeFilter()) {
            <i class="fa-solid fa-check text-white" style="font-size: 9px"></i>
          }
        </span>
        <span>{{ '#PMS_ROSTER.FILTER_ABSENCES' | translate }}</span>
      </div>
    </soft-menu>
  </soft-menu-bar-dropdown>
</ng-template>

<ng-template #viewTrailingMenuBar>
  <soft-menu-bar-pill-switch
    [options]="detailPillOptions()"
    [value]="hostComponent.calendarDetails()"
    (valueChange)="setDetailOption($event)"
    [tooltip]="('#PMS_ROSTER.DETAILS' | translate) ?? ''"
    [responsive]="true"
  />
</ng-template>

<ng-template #selectionLeadingMenuBar>
  @if (!multiSelect()) {
    <soft-menu-bar-button
      variant="primary"
      icon="fa-regular fa-pencil"
      [label]="('#PMS_ROSTER.EDIT' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.EDIT' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('edit')"
    />
  }

  @if (!isAppointment()) {
    <div class="self-stretch w-px bg-border select-none mx-1"></div>
    <soft-menu-bar-button
      [label]="('#PMS_ROSTER.DUPLICATE' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.DUPLICATE' | translate) ?? ''"
      icon="fa-regular fa-copy"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('duplicate')"
    />
    <div class="self-stretch w-px bg-border select-none mx-1"></div>
    <soft-menu-bar-button
      icon="fa-regular fa-copy"
      [label]="('#PMS_ROSTER.COPY' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.COPY' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('copy')"
    />
    <div class="self-stretch w-px bg-border select-none mx-1"></div>
    <!--soft-menu-bar-button
      icon="fa-regular fa-arrow-right"
      [label]="('#PMS_ROSTER.COPY_TO_NEXT_MONDAY' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.COPY_TO_NEXT_MONDAY' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('copyToNextMonday')"
    /-->

    <soft-menu-bar-button
      icon="fa-regular fa-trash-alt"
      [label]="('#PMS_ROSTER.DELETE' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.DELETE' | translate) ?? ''"
      variant="danger"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('delete')"
    />
  }

  @if (showTicketEventOptions()) {
    <div class="self-stretch w-px bg-border select-none mx-1"></div>

    <soft-menu-bar-button
      icon="fa-regular fa-copy"
      [label]="('#PMS_ROSTER.COPY_TICKET_NR' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.COPY_TICKET_NR' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('copyTicketKey')"
    />
    <div class="self-stretch w-px bg-border select-none mx-1"></div>
    <soft-menu-bar-button
      icon="fa-regular fa-up-right-from-square"
      [label]="('#PMS_ROSTER.OPEN_TICKET' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.OPEN_TICKET' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('openTicket')"
    />
  }

  @if (showProjectEventOptions()) {
    <div class="self-stretch w-px bg-border select-none mx-1"></div>

    <soft-menu-bar-button
      icon="fa-regular fa-copy"
      [label]="('#PMS_ROSTER.COPY_OBJECT_NR' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.COPY_OBJECT_NR' | translate) ?? ''"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('copyProjectKey')"
    />
  }

  @if (!isAppointment() && !multiSelect()) {
    <div class="self-stretch w-px bg-border select-none mx-1"></div>

    <soft-menu-bar-dropdown
      icon="fa-regular fa-circle"
      [label]="('#PMS_ROSTER.CHANGE_STATUS' | translate) ?? ''"
      [tooltip]="('#PMS_ROSTER.CHANGE_STATUS' | translate) ?? ''"
      [responsive]="true"
    >
      <soft-menu *softMenuBarDropdownContent class="min-w-44">
        <soft-menu-item
          icon="fa-regular fa-circle"
          [label]="('#PMS_ROSTER.STATUS_UNDEFINED' | translate) ?? ''"
          (click)="this.service.handleContextMenuAction('changeStatus:UNDEFINED')"
          [value]=""
        />
        <soft-menu-item
          [value]=""
          icon="fa-regular fa-circle-check"
          [label]="('#PMS_ROSTER.STATUS_DONE' | translate) ?? ''"
          (click)="this.service.handleContextMenuAction('changeStatus:DONE')"
        />
        <soft-menu-item
          icon="fa-regular fa-share"
          [label]="('#PMS_ROSTER.STATUS_FORWARDED' | translate) ?? ''"
          (click)="
            this.service.handleContextMenuAction('changeStatus:HANDOVER_TO_OTHERS')
          "
          [value]=""
        />
      </soft-menu>
    </soft-menu-bar-dropdown>
  }
</ng-template>

<ng-template #selectionTrailingMenuBar>
  <span class="text-xs text-foreground/70 px-1">
    <span class="font-semibold">{{ selectedEvents().length }}</span>
    {{ '#PMS_ROSTER.SELECTED' | translate }}
  </span>
</ng-template>

<ng-template #eventMenu>
  <soft-ds-context-menu>
    @if (!multiSelect()) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-pen"
        label="Editieren"
        (triggered)="service.handleContextMenuAction('edit')"
      />
    }

    @if (!isAppointment()) {
      @if (!multiSelect()) {
        <soft-ds-context-menu-divider />
      }
      <soft-ds-context-menu-item
        icon="fa-regular fa-clone"
        label="Duplizieren"
        (triggered)="service.handleContextMenuAction('duplicate')"
      />
      <soft-ds-context-menu-item
        icon="fa-regular fa-copy"
        label="Kopieren"
        [keyboardShortcut]="[modifierKey, 'C']"
        (triggered)="service.handleContextMenuAction('copy')"
      />
      <soft-ds-context-menu-item
        icon="fa-regular fa-arrow-right"
        label="Auf nä. Montag kopieren"
        (triggered)="service.handleContextMenuAction('copyToNextMonday')"
      />
    }

    @if (!multiSelect() && (isTicket() || isProject())) {
      <soft-ds-context-menu-divider />
      @if (isTicket()) {
        <soft-ds-context-menu-item
          icon="fa-regular fa-copy"
          label="Ticket-Nr. kopieren"
          [submenu]="ticketCopySubmenu"
          splitSubmenu
          (triggered)="service.handleContextMenuAction('copyTicketKey')"
        />
        <soft-ds-context-menu-item
          icon="fa-regular fa-up-right-from-square"
          label="Ticket öffnen"
          (triggered)="service.handleContextMenuAction('openTicket')"
        />
      }
      @if (isProject()) {
        <soft-ds-context-menu-item
          icon="fa-regular fa-copy"
          label="Objekt-Nr. kopieren"
          (triggered)="service.handleContextMenuAction('copyProjectKey')"
        />
      }
    }

    @if (!isAppointment()) {
      <soft-ds-context-menu-divider />
      <soft-ds-context-menu-item
        icon="fa-regular fa-circle"
        label="Status ändern"
        [submenu]="statusSubmenu"
      />

      <soft-ds-context-menu-divider />
      <soft-ds-context-menu-item
        icon="fa-regular fa-trash-can"
        label="Löschen"
        variant="danger"
        (triggered)="service.handleContextMenuAction('delete')"
      />
    }
  </soft-ds-context-menu>
</ng-template>

<ng-template #ticketCopySubmenu>
  <soft-ds-context-menu>
    <soft-ds-context-menu-item
      icon="fa-regular fa-clipboard"
      label="Nr. - Name kopieren"
      (triggered)="service.handleContextMenuAction('copyTicketKeyAndName')"
    />
  </soft-ds-context-menu>
</ng-template>

<ng-template #statusSubmenu>
  <soft-ds-context-menu>
    <soft-ds-context-menu-item
      icon="fa-regular fa-circle"
      label="Undefiniert"
      (triggered)="service.handleContextMenuAction('changeStatus:UNDEFINED')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-circle-check"
      label="Erledigt"
      (triggered)="service.handleContextMenuAction('changeStatus:DONE')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-share"
      label="Weitergeleitet"
      (triggered)="service.handleContextMenuAction('changeStatus:HANDOVER_TO_OTHERS')"
    />
  </soft-ds-context-menu>
</ng-template>

<ng-template #calendarMenu>
  <soft-ds-context-menu>
    <soft-ds-context-menu-item
      icon="fa-regular fa-calendar-plus"
      label="Neuer Eintrag"
      (triggered)="service.handleContextMenuAction('create')"
    />
    @if (hasClipboardEvent()) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-paste"
        label="Einfügen"
        [keyboardShortcut]="[modifierKey, 'V']"
        (triggered)="service.handleContextMenuAction('paste')"
      />
    }
  </soft-ds-context-menu>
</ng-template>
